/**
 * Created by danielr on 12/30/15.
 */

define(function (require) {
    "use strict";

    var RevisionedModel = require("models/RevisionedModel");
    var LPAuthModel = {};

    var KEYS = {
        GEN_KEY_URL: "genKeyUrl",
        VAL_KEY_URL: "valKeyUrl"
    };

    var CONST = {
        URL_NOT_VALID_ERR_MSG: "LEManager.manager.dataSources.authentication.server.url.not.valid",
        HTTPS_MANDATORY_URL_ERROR_MSG: "LEManager.manager.dataSources.authentication.server.https.mandatory"
    };

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {
        LPAuthModel = RevisionedModel.extend({
            defaults: {
                "genKeyUrl": "",
                "valKeyUrl": ""
            },
            name: "LPAuthModel",

            initialize: function (options) {
                this.isNewAuthType = true;
                RevisionedModel.prototype.initialize.call(this, options);
            },

            validation: {
                "genKeyUrl": [
                    {
                        fn: function () {
                            var genKeyUrl = this.getGeneratedKeyUrl();
                            return this._validateUrlAttribute(genKeyUrl);
                        }
                    }
                ],
                "valKeyUrl": [
                    {
                        fn: function () {
                            var valKeyUrl = this.getKeyUrlValue();
                            return this._validateUrlAttribute(valKeyUrl);
                        }
                    }
                ]
            },

            _getValue: function (key) {
                return this.get(key);
            },
            _setValue: function (key, value) {
                this.set(key, value);
            },


            /* private getter setter */

            getGeneratedKeyUrl: function () {
                return this._getValue(KEYS.GEN_KEY_URL);
            },
            setGeneratedKeyUrl: function (url) {
                this._setValue(KEYS.GEN_KEY_URL, url.trim());
            },

            getKeyUrlValue: function () {
                return this._getValue(KEYS.VAL_KEY_URL);
            },
            setKeyUrlValue: function (url) {
                this._setValue(KEYS.VAL_KEY_URL, url.trim());
            },

            _allFieldsEmpty: function(){
                return _.isEmpty(this.getGeneratedKeyUrl()) &&
                    _.isEmpty(this.getKeyUrlValue());
            },

            _validateUrlAttribute: function(url){
                if(!_.isEmpty(url)){
                    //if url is not empty validate it
                    return this._getUrlValidationErrorMessage(url);
                }
                else {
                    //if it is the only url to be empty then throw a not valid url message
                    //if (!this._allFieldsEmpty() || (this._allFieldsEmpty() && this.isNewAuthType)){
                        return CONST.URL_NOT_VALID_ERR_MSG;
                    //}
                }
            },

            _getUrlValidationErrorMessage:function(url){
                url = url.trim();

                if(_.isNull(url.match(Backbone.Validation.patterns.httpsOnly))){
                    return CONST.HTTPS_MANDATORY_URL_ERROR_MSG;
                }
                if(_.isNull(url.match(Backbone.Validation.patterns.fullUrl))){
                    return CONST.URL_NOT_VALID_ERR_MSG;
                }
            },

            setIsNewAuth: function(value){
                this.isNewAuthType = value;
            },

            isDeleteAction: function(){
                return false; //Delete action is temporarly disabled until new PROD and UX final decision
                //return this._allFieldsEmpty() && !this.isNewAuthType;
            }


        });
    });



    LPAuthModel.KEYS = KEYS;
    return LPAuthModel;
});

